export const ATTRIBUTED = 'attributed';
export const CROSS_DEVICE_OTT = 'cross_device_ott';
export const FROM_DESKTOP = 'from_desktop';
export const LAST_ATTRIBUTED_TOUCH_DATA_DOLLAR_3P = 'last_attributed_touch_data_dollar_3p';
export const LAST_ATTRIBUTED_TOUCH_DATA_PLUS_CURRENT_FEATURE = 'last_attributed_touch_data_plus_current_feature';
export const LAST_ATTRIBUTED_TOUCH_DATA_PLUS_VIA_FEATURES = 'last_attributed_touch_data_plus_via_features';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ADVERTISING_PARTNER_NAME =
  'last_attributed_touch_data_tilde_advertising_partner_name';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_AD_ID = 'last_attributed_touch_data_tilde_ad_id';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_AD_NAME = 'last_attributed_touch_data_tilde_ad_name';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_AD_SET_ID = 'last_attributed_touch_data_tilde_ad_set_id';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_AD_SET_NAME = 'last_attributed_touch_data_tilde_ad_set_name';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_AGENCY_ID = 'last_attributed_touch_data_tilde_agency_id';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_AGENCY_NAME = 'last_attributed_touch_data_tilde_agency';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CAMPAIGN_ID = 'last_attributed_touch_data_tilde_campaign_id';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CAMPAIGN_NAME = 'last_attributed_touch_data_tilde_campaign';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CONTENT_ID = 'last_attributed_touch_data_tilde_content_id';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CREATIVE_ID = 'last_attributed_touch_data_tilde_creative_id';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CREATIVE_NAME = 'last_attributed_touch_data_tilde_creative_name';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_FEATURE = 'last_attributed_touch_data_tilde_feature';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_KEYWORD = 'last_attributed_touch_data_tilde_keyword';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_PLACEMENT = 'last_attributed_touch_data_tilde_placement';
export const LAST_ATTRIBUTED_TOUCH_DATA_TILDE_TAGS = 'last_attributed_touch_data_tilde_tags';
export const LAST_ATTRIBUTED_TOUCH_TYPE = 'last_attributed_touch_type';
export const OTT = 'ott';
export const USER_DATA_COUNTRY = 'user_data_geo_country_code';
export const USER_DATA_ENVIRONMENT = 'user_data_environment';
export const USER_DATA_MODEL = 'user_data_model';
export const USER_DATA_OS = 'user_data_os';
export const USER_DATA_OS_VERSION = 'user_data_os_version';
export const USER_DATA_PLATFORM = 'user_data_platform';
export const LOCAL_CURRENCY = 'event_data_local_currency';

export const INSTALL_COHORT_DAY_DIMENSION = 'install_activity_timezone_adjusted_day';
export const REENGAGEMENT_COHORT_DAY_DIMENSION = 'reengagement_activity_timezone_adjusted_day';
